const LocalesEnum = Object.freeze({
  cs: 'Čeština',
  de: 'Deutsch',
  fr: 'Français',
  sk: 'Slovenčina',
  es: 'Español',
  en: 'English',
})

export default LocalesEnum
